"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var HelpDialog = function HelpDialog(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 89 94"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-2.000000, -12.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(2.000000, 12.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M44.5,0 C19.9040041,0 0,19.8802656 0,44.4480469 C0,56.2257695 4.58680992,66.9267148 12.0400083,74.8509883 L2.83549587,89.7912969 C1.41057645,92.1042109 3.88473967,94.9032813 6.37232645,93.7191016 L25.4582293,84.6326797 C31.4232521,87.4627773 37.821874,88.8962773 44.5,88.8962773 C69.0959959,88.8962773 89,69.0160117 89,44.4482305 C89,19.8929336 69.110155,0 44.5,0 Z M43.1740299,67.1724844 C40.589543,67.1724844 38.6060996,65.0111031 38.6060996,62.5494141 C38.6060996,60.0277157 40.6496474,57.9263438 43.1740299,57.9263438 C45.6986737,57.9263438 47.8023259,60.0277157 47.8023259,62.5494141 C47.8023259,65.0111031 45.7587781,67.1724844 43.1740299,67.1724844 Z M50.026448,43.8168346 C46.7207089,46.3985424 46.6603433,48.1998673 46.6603433,51.3219204 C46.6603433,52.4626204 46.0592998,53.7836095 43.1141869,53.7836095 C40.6496474,53.7836095 39.8084478,52.882947 39.8084478,49.7608939 C39.8084478,44.5974783 42.092413,42.1357892 43.835439,40.6347721 C45.8191438,38.9537268 49.1852485,37.0923924 49.1852485,33.8503206 C49.1852485,31.0885846 46.7808133,29.7675956 43.775596,29.7675956 C37.6446914,29.7675956 38.966987,34.3906659 35.721091,34.3906659 C34.0982736,34.3906659 32.1148302,33.3099752 32.1148302,30.9685659 C32.1148302,27.7262331 35.841561,22.9231347 43.955909,22.9231347 C51.6495266,22.9231347 56.7586574,27.1858878 56.7586574,32.8296393 C56.7583961,38.4733908 51.6492653,42.5561158 50.026448,43.8168346 Z"
  })))));
};
/* eslint-enable */
var _default = HelpDialog;
exports["default"] = _default;